export default __webpack_public_path__ + "static/media/rbl_sblpress_logo.e08ce79e.jpg";